interface PDFViewerProps {
  pdfSource: string // Can be base64 (data:application/pdf;base64,...) or URL
  className?: string
  title?: string
}

/**
 * Universal PDF Viewer component
 * Supports both base64 and URL sources
 * 
 * Usage:
 * - Preview: <PDFViewer pdfSource={`data:application/pdf;base64,${base64}`} />
 * - Documents: <PDFViewer pdfSource={quote.pdfUrl} />
 */
export function PDFViewer({ pdfSource, className = 'w-full h-full', title = 'PDF Viewer' }: PDFViewerProps) {
  return (
    <embed
      src={pdfSource}
      type="application/pdf"
      className={className}
      title={title}
    />
  )
}
